import { Table } from "../../../../../ui/components/Table";
import { Accordion } from "../../../../../ui/components/Accordion";
import type { AccountantStatusTransactionsDetailEntity } from "../../../domain/entities/AccountantStatusEntity";

interface TransactionsDetailSectionProps {
  data: AccountantStatusTransactionsDetailEntity | null;
  loading: boolean;
  error: string | null;
}

export function TransactionsDetailSection({
  data,
  loading,
  error,
}: TransactionsDetailSectionProps) {
  if (loading) {
    return <div className="h-44 w-full animate-pulse rounded-md bg-neutral-100" />;
  }
  if (error) {
    return (
      <div className="w-full rounded-md border border-solid border-error-200 bg-error-50 px-4 py-3">
        <span className="text-body font-body text-error-700">{error}</span>
      </div>
    );
  }
  if (!data) return null;

  return (
    <div className="flex w-full flex-col items-start gap-4 rounded-md border border-solid border-neutral-border bg-default-background shadow-sm">
      <Accordion
        trigger={
          <div className="flex w-full items-center gap-2 px-6 py-6">
            <div className="flex grow shrink-0 basis-0 items-center gap-4">
              <span className="text-heading-3 font-heading-3 text-default-font">
                Bank Transactions for {data.month} {data.year}
              </span>
            </div>
            <Accordion.Chevron />
          </div>
        }
        defaultOpen={true}
      >
        <div className="flex w-full flex-col items-start gap-4 border-t border-solid border-neutral-border px-6 py-6">
          <div className="flex w-full items-center gap-2">
            <span className="text-body font-body text-default-font">
              Fetched: {data.fetched}
            </span>
            <span className="text-body font-body text-subtext-color">•</span>
            <span className="text-body font-body text-success-600">
              Categorized: {data.categorized}
            </span>
            <span className="text-body font-body text-subtext-color">•</span>
            <span className="text-body font-body text-warning-600">
              Needs review: {data.needsReview}
            </span>
          </div>
          <div className="flex w-full flex-col items-start gap-2 overflow-x-auto">
            <Table
              header={
                <Table.HeaderRow>
                  <Table.HeaderCell>Bank Account</Table.HeaderCell>
                  <Table.HeaderCell>Transactions Fetched</Table.HeaderCell>
                  <Table.HeaderCell>Categorized</Table.HeaderCell>
                  <Table.HeaderCell>Needs Review</Table.HeaderCell>
                </Table.HeaderRow>
              }
            >
              {data.accounts.map((account, idx) => (
                <Table.Row key={`${account.accountName}-${idx}`}>
                  <Table.Cell>
                    <span className="whitespace-nowrap text-body-bold font-body-bold text-default-font">
                      {account.accountName}
                    </span>
                  </Table.Cell>
                  <Table.Cell>{account.transactionsFetched}</Table.Cell>
                  <Table.Cell>
                    <span className="whitespace-nowrap text-body font-body text-success-600">
                      {account.categorized}
                    </span>
                  </Table.Cell>
                  <Table.Cell>
                    <span className="whitespace-nowrap text-body font-body text-warning-600">
                      {account.needsReview}
                    </span>
                  </Table.Cell>
                </Table.Row>
              ))}
            </Table>
          </div>
        </div>
      </Accordion>
    </div>
  );
}
